import UiDetail from "./UiDetail";
import { EnumMiezzFormItemType, MiezzFormItem } from "@/models/MiezzForm";
import { EnumPipe } from "@/models/EnumPipe";
import UiGroup from "./UiGroup";

/**
 * 交期要求详细
 * @description 自动生成的代码,请勿修改
 */
export default class DtoDetailDeliveryRequirement extends UiDetail<string> {
    constructor() {
        //无参构造函数
        super()
    }

    [proName: string]: any;
    /**
     * 名称
     */
    Name?: string;
}

/**
 * 交期要求详细-表单校验
 */
export const DtoDetailDeliveryRequirementRules = {
}

/**
 * 交期要求详细-设置项
 */
export const DtoDetailDeliveryRequirementMiezzDetailItems: MiezzFormItem[] = [
  {
    Prop: "Name",
    Label: "名称",
    Type: EnumMiezzFormItemType.Text,
  },
]
